import type { NotificationPreference } from '@seek/hirer-notification-preference';
import type { TeamMemberForJobAccess } from '@seek/hirer-team-member-job-access';

import type { NotificationsSetting } from 'src/types/notificationsSetting';

const defaultState: NotificationsSetting = {
  activeNotificationStep: 0,
  isInSettingMode: false,
  isSettingCompleted: false,
  hasTeamMemberNotifySelected: false,
};

export const UPDATE_SAVED_NOTIFICATION_PREFERENCE =
  'session/notificationsSetting/updateSavedNotificationPreference';
export const UPDATE_ACTIVE_NOTIFICATION_STEP =
  'session/notificationsSetting/updateActiveNotificationStep';
export const UPDATE_TEAM_MEMBER_NOTIFY_SELECTED =
  'session/notificationsSetting/hasTeamMemberNotifySelected';
export const START_SETTING_MODE =
  'session/notificationsSetting/startSettingMode';
export const COMPLETE_SETTING = 'session/notificationsSetting/completeSetting';
export const SETTING_WITH_ERROR =
  'session/notificationsSetting/settingWithError';
export const UPDATE_SAVED_TEAM_MEMBER_JOB_ACCESS_LIST =
  'session/notificationsSetting/updateSavedTeamMemberJobAccessList';
export const RESET_NOTIFY_STATE =
  'session/notificationsSetting/resetNotifyState';
export const RESET = 'session/notificationsSetting/reset';

export const actionSetSavedNotificationPreference = (
  value?: NotificationPreference,
) => ({
  type: UPDATE_SAVED_NOTIFICATION_PREFERENCE,
  value,
});

export const actionUpdateActiveNotificationStep = (value: number) => ({
  type: UPDATE_ACTIVE_NOTIFICATION_STEP,
  value,
});

export const actionUpdateHasTeamMemberNotifySelected = (value: boolean) => ({
  type: UPDATE_TEAM_MEMBER_NOTIFY_SELECTED,
  value,
});

export const actionStartSettingMode = () => ({
  type: START_SETTING_MODE,
});

export const actionCompleteSetting = () => ({
  type: COMPLETE_SETTING,
});

export const actionSettingWithServerError = () => ({
  type: SETTING_WITH_ERROR,
});
export const actionSetSavedTeamMemberJobAccessList = (
  value?: TeamMemberForJobAccess[],
) => ({
  type: UPDATE_SAVED_TEAM_MEMBER_JOB_ACCESS_LIST,
  value,
});

export const actionResetTeamMemberNotifyState = (value: number) => ({
  type: RESET_NOTIFY_STATE,
  value,
});

export const actionResetNotificationsSetting = () => ({
  type: RESET,
});

export default (
  state = defaultState,
  { type, value }: { type: string; value?: any },
): NotificationsSetting => {
  switch (type) {
    case UPDATE_ACTIVE_NOTIFICATION_STEP: {
      return {
        ...state,
        activeNotificationStep: value,
      };
    }
    case UPDATE_SAVED_NOTIFICATION_PREFERENCE: {
      return {
        ...state,
        savedNotificationPreference: value,
      };
    }
    case UPDATE_TEAM_MEMBER_NOTIFY_SELECTED: {
      return {
        ...state,
        hasTeamMemberNotifySelected: value,
      };
    }
    case START_SETTING_MODE: {
      return { ...state, isInSettingMode: true, activeNotificationStep: 0 };
    }
    case COMPLETE_SETTING: {
      return { ...state, isInSettingMode: false, isSettingCompleted: true };
    }
    case SETTING_WITH_ERROR: {
      return { ...state, isInSettingMode: false, isSettingCompleted: false };
    }
    case UPDATE_SAVED_TEAM_MEMBER_JOB_ACCESS_LIST: {
      return {
        ...state,
        savedTeamMemberJobAccessList: value,
      };
    }
    case RESET_NOTIFY_STATE: {
      return {
        ...state,
        activeNotificationStep: value,
        hasTeamMemberNotifySelected: false,
      };
    }
    case RESET: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
};
